import { render } from "./SchedaVisualizzazioneAzienda.vue?vue&type=template&id=99bd13b8"
import script from "./SchedaVisualizzazioneAzienda.vue?vue&type=script&lang=js"
export * from "./SchedaVisualizzazioneAzienda.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__